<script setup>
import { useActiveDeviceRenderStore } from "@/stores/activeDeviceRender";
import { useWebsiteStore } from "@/stores/website";

const activeDeviceRender = useActiveDeviceRenderStore();
const websiteStore = useWebsiteStore();
async function recheckPage(pageUrl) {
  await websiteStore.recheckPage(pageUrl);
}
</script>
<template>
  <div class="alert alert-danger" role="alert">
    <p class="mb-0"><b>Page Scanning Error</b><br>
      We ran into some issues scanning your page.<br>
      The scan credits was added back to your account, please retry in a few minutes.
    </p>
    <button class="btn btn-sm btn-secondary" @click.prevent="recheckPage(activeDeviceRender.page.url)">Retry</button>
  </div>
</template>

<style>


.issue-alert a {
  color: white;
  text-decoration: underline;
}

</style>